/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Set the loading states
 *
 * @param  {[type]} state
 * @return {[type]}
 */
const BEGIN_UPLOAD = (state) => {
    state.error = null
    state.uploading = true
}

/**
 * Set the data on a successful POST
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const SET_DATA = (state, payload) => {
    state.category_list = payload.category_list
    state.mappings = payload.mappings.map((item, idx) => {
        item.id = idx + 1
        return item
    })
    state.meta = payload.meta
    state.miscinc = payload.miscinc
    state.file_name = payload.file_name
    state.date = payload.date
    state.uploading = false
}

/**
 * Set the error state on failed POST
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_DATA_ERROR = (state, error) => {
    state.error = error
    state.uploading = false
}

/**
 * Update the progress
 *
 * @param  {Object} state
 * @param  {Number} progress
 * @return {Void}
 */
const UPDATE_UPLOAD_PROGRESS = (state, progress) => {
    state.progress = progress
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Set the modal state (true)
 *
 * @param  {Object} state
 * @return {Void}
 */
const SHOW_MODAL = (state) => {
    state.showModal = true
}

/**
 * Change the selected category state
 *
 * @param  {Object} state
 * @param  {String} category
 * @return {Void}
 */
const UPDATE_SELECTED_CATEGORY = (state, payload) => {
    state.selectedCategory = payload.cat
    state.selectedColorIndex = payload.idx
    state.searchTerm = null
}

/**
 * Set the modal state (false)
 *
 * @param  {Object} state
 * @return {Void}
 */
const HIDE_MODAL = (state) => {
    state.showModal = false
}

/**
 * Update an item's category
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const UPDATE_ITEM_CATEGORY = (state, payload) => {
    let item = state.mappings.find(item => item.id === payload.id)

    item.our_category = payload.category
}

/**
 * Change the search term
 *
 * @param  {Object} state
 * @param  {String} payload
 * @return {Void}
 */
const UPDATE_SEARCH_TERM = (state, payload) => {
    state.searchTerm = payload
}

/**
 * Import success
 *
 * @param  {Object} state
 * @return {Void}
 */
const IMPORT_SUCCESS = (state) => {
    state.imported = true
    state.saving = false
}

/**
 *
 * @param  {Object} state
 * @return {Void}
 */
const IMPORT_BEGIN = (state) => {
    state.saving = true
}

/**
 * Handle a successful request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const SUPPORT_REQUEST_SUCCESS = (state, payload) => {
    state.helpRequested = true
    state.requestingHelp = false
}

/**
 * Handle a failed request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const SUPPORT_REQUEST_FAILURE = (state, error) => {
    state.helpRequested = true
    state.requestingHelp = false
}

/**
 * Set the loading indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
const REQUEST_FILE_ASSISTANCE = state => {
    state.requestingHelp = true
}

export default {
    SET_DATA,
    SHOW_MODAL,
    HIDE_MODAL,
    RESET_STATE,
    IMPORT_BEGIN,
    BEGIN_UPLOAD,
    SET_DATA_ERROR,
    IMPORT_SUCCESS,
    UPDATE_SEARCH_TERM,
    UPDATE_ITEM_CATEGORY,
    UPDATE_UPLOAD_PROGRESS,
    SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE,
    REQUEST_FILE_ASSISTANCE,
    UPDATE_SELECTED_CATEGORY
}



// WEBPACK FOOTER //
// ./src/state/modules/opex-importer/mutations.js